import { IProduct } from 'types/interfaces';

class ProductService {
  public filterValidProducts(products: IProduct[]) {
    const productsList: IProduct[] = [];

    products.forEach(product => {
      if (!product.isValid && product.children?.length === 0) {
        return;
      }

      const newProduct = JSON.parse(JSON.stringify(product));

      if (product.children && product.children?.length > 0) {
        newProduct.children = product.children.filter(child => child.isValid);
      }

      if (newProduct.children && newProduct.children?.length > 0) {
        productsList.push(newProduct);
        return;
      }

      if (!newProduct.children?.length && !newProduct.isValid) {
        return;
      }

      productsList.push(product);
    });

    return productsList;
  }
}

export { ProductService };
export default new ProductService();
